export const GET_LOANSLIP = "GET_LOANSLIP";
export const GET_LOANSLIP_ID = "GET_LOANSLIP_ID";
export const GET_LOANSLIP_DELETED = "GET_LOANSLIP_DELETED";
export const GET_LOANSLIP_DELETED_ID = "GET_LOANSLIP_DELETED_ID";
export const GET_LOANSLIP_LINK = "GET_LOANSLIP_LINK";
export const GET_LOANSLIP_REQUEST_LINK = "GET_LOANSLIP_REQUEST_LINK";

